.searchbar {
	display: grid;
	grid-template-areas: "icon input button";
	grid-template-columns: 0px 1fr auto;
	align-items: center;
	width: 300px;
	height: 42px;
	background-color: var(--elevation-low);
}

.searchIcon {
	grid-area: icon;
	z-index: 2;
	color: var(--content-tertiary);
	margin-inline-start: 8px;
}

.input {
	grid-area: input;
	height: 100%;
	border: solid var(--border-primary) 1px;
	background-color: transparent;
	color: var(--content-primary);
	border-radius: 6px;
	padding: 0 32px;

	&::-webkit-search-cancel-button,
	&::-webkit-search-decoration {
		-webkit-appearance: none;
	}

	&:hover {
		background-color: var(--elevation-medium);
	}
}

.input[data-focus-visible],
.input:focus-visible {
	outline: var(--focus-outline);
}

.closeButton {
	all: unset;
	grid-area: button;
	cursor: pointer;
	width: 16px;
	height: 16px;
	border-radius: 9999px;
	margin-left: -28px;
	color: var(--content-tertiary);
	display: flex;
	align-items: center;
	justify-content: center;
	-webkit-tap-highlight-color: transparent;
}
